import { useDebounce } from 'ahooks'

export function useChatBoxDebounce<T>(value: T): T {
  return useDebounce<T>(value, { wait: 100 })
}
